import { useQuery } from "react-query";
import axios from "infra/http";

function useGetInadimplencia() {
  return useQuery("/v1/motivo-inadimplencia", async () => {
    const res = await axios.get("/v1/motivo-inadimplencia");

    return res.data;
  });
}

export default useGetInadimplencia;
